import React from 'react'
import { getFlag } from '../../utils/selector'

let ErrorBoundary = props => {
  const { children } = props
  return children
}

let Bugsnag

if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test') {
  const BugsnagPluginReact = require('@bugsnag/plugin-react')
  Bugsnag = require('@bugsnag/js')

  Bugsnag.start({
    apiKey: process.env.REACT_APP_BUGSNAG_KEY,
    appVersion: process.env.REACT_APP_VERSION,
    enabledReleaseStages: [ 'app.wudev.com', 'app.wustage.com', 'app.wufoo.com' ],
    plugins: [ new BugsnagPluginReact() ],
    releaseStage: getFlag('domain')
  })

  ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)
}

export const assignBugsnagUser = user => {
  Bugsnag?.addMetadata('user', { // eslint-disable-line no-unused-expressions
    name: user.name,
    email: user.email,
    id: user.id
  })
}

export const getBugsnag = () => {
  return Bugsnag
}

export default ErrorBoundary
